var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.98092 4.10587C3.00262 5.08417 3.10972 5.19127 3.49177 5.57332L6.42668 8.50823C6.80873 8.89028 6.91583 8.99738 7.89413 8.01908C8.87243 7.04078 10.3399 7.52993 11.3182 8.50823C12.2965 9.48653 12.2965 9.48653 10.829 10.954C9.36158 12.4214 6.42668 12.4214 4.47007 10.4648L1.53517 7.52993C-0.421433 5.57332 -0.421433 2.63842 1.04602 1.17097C2.51347 -0.296485 2.51347 -0.296486 3.49177 0.681816C4.47007 1.66012 4.95922 3.12757 3.98092 4.10587Z","fill":"white"}));
}

Phone.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
